<template>
    <div class=" uk-light layout-photo-album"  v-if="!loading && photoAlbum">

        <div v-if="photoAlbum.photos && photoAlbum.photos.nodes.length > 0" :key="`${photoAlbum.id}-${photoAlbum.photos.nodes.length}`">
            
            <div class="uk-position-relative uk-visible@m" uk-slider v-keyboard-slide>

                <div class="uk-position-top-left uk-width-1-3@m uk-padding album-description">
                    <h2 class="uk-margin-small-bottom"><router-link to=".." class="text-green"><span class="uk-icon" uk-icon="chevron-left"></span></router-link> {{photoAlbum.title}}</h2>
                    <small>{{ moment(photoAlbum.created).format('MMM DD, YYYY') }}</small>

                    <div class="content" v-html="photoAlbum.content" v-if="!!photoAlbum.content"></div>
                </div>

                <ul class="uk-slider-items">
                    <li class="uk-width-1-1" v-for="photo in photoAlbum.photos.nodes" :key="photo.link">

                        <div class="uk-position-top-right uk-position-medium zoom">
                            <a class="uk-icon" :uk-icon="`icon: ${zoom ? 'shrink' : 'expand'}; ratio: 1.2`" @click.stop="zoom = !zoom"></a>
                        </div>

                        <div class="uk-flex uk-grid-collapse k-grid-divider" uk-grid>
                            <div class="uk-width-1-3@l uk-width-2-5@m">

                                <!-- <h4 class="text-green uk-margin-remove-bottom" v-if="entry.Prize && entry.Prize.ID > 0"><label>${{parseInt(entry.Prize.Prize).toLocaleString('en-US')}} {{entry.Prize.title}}</label></h4> -->

                                <div class="uk-position-bottom uk-padding photo-description">
                                    <div uk-slider-parallax="x: 100,-100">
                                        <h4 v-if="photo.title">{{photo.title}}</h4>
                                        <p v-if="photo.caption">{{photo.caption}}</p>
                                    </div>
                                    <div uk-slider-parallax="x: 100,-100">
                                        <a :href="photo.image.url" class="uk-button uk-button-outline" v-bind:download="`LMC - ${photoAlbum.title} - ${photo.title}`" target="_blank" uk-slider-parallax="x: -100,100">
                                            <i class="uk-icon" uk-icon="icon: download" />
                                            Download Photo
                                        </a>
                                    </div>

                                </div>
                            </div>

                            <div class="uk-width-2-3@l uk-width-3-5@m photo-container">
                                <div v-bind:class="zoom ? 'uk-background-cover' : 'uk-background-contain'" v-bind:style="{ backgroundImage: `url(${photo.image.large})` }" uk-height-viewport="offset-top: true; offset-bottom: 15"></div>
                            </div>
                        </div>
                    </li>
                </ul>

                <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous uk-slider-item="previous" ref="previous"></a>
                <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next uk-slider-item="next" ref="next"></a>

            </div>

            <div class="uk-position-relative uk-hidden@m">

                <div class="uk-width-1-3@l uk-padding album-description">
                    <h2 class="uk-margin-small-bottom uk-margin-large-top"><router-link to=".." class="text-green"><span class="uk-icon" uk-icon="chevron-left"></span></router-link> {{photoAlbum.title}}</h2>
                    <p><small>{{ moment(photoAlbum.created).format('MMM DD, YYYY') }}</small></p>

                    <div class="content" v-html="photoAlbum.content" v-if="!!photoAlbum.content"></div>
                </div>

                <div v-for="photo in photoAlbum.photos.nodes" :key="photo.Link">
                    <img :src="photo.image.medium" alt="photo.title" />
                    <div class="uk-width-1-1 uk-padding uk-hidden@m" uk-slider-parallax="x: 100,-100">
                        <h4 v-if="photo.title">{{photo.title}}</h4>
                        <p v-if="photo.caption">{{photo.caption}}</p>
                    </div>
                </div>
            </div>

        </div>
        <div class="uk-section uk-text-center" v-else>
            <div uk-spinner></div>
        </div>


        <!-- <div class="uk-background-dark uk-section uk-section-medium uk-light uk-visible@l" v-if="!loading && photoAlbum">
          <div class="uk-container uk-container-large">
              <ul class="uk-breadcrumb">
                  <li><router-link to="../.." class="text-green"><label>MEDIA</label></router-link></li>
                  <li><router-link to="..">Photo Gallery</router-link></li>
                  <li><span>{{photoAlbum.title}}</span></li>
              </ul>
          </div>
        </div> -->

  </div>
</template>

<script>
// import ProjectCard from '../ProjectCard.vue'
// import FloatingBadge  from '../../components/FloatingBadge.vue'
import gql from 'graphql-tag'

// GraphQL query
const readPhotoAlbumQuery = gql`
    query($urlSegment: String!) {
      readOnePhotoAlbum(filter: { urlSegment: { eq: $urlSegment }}){
        created
        content
        title
        link
        photos {
            nodes {
                title
                caption
                image {
                    small
                    medium
                    large
                    url
                }
            }
        }
      }
    }
`

export default {
    inject: ['state', 'moment'],
    data() {
        return {
            photoAlbum: {},
            zoom: 0
        }
    },
    components: {
        // ProjectCard,
        // FloatingBadge
    },
    methods: {
        photoURL(photo) {
            console.log(photo);
            if(window.innerWidth < 900) {
                return photo.medium;
            }
            return photo.url;
        }
    },
    apollo: {
        photoAlbum: {
            // GraphQL query
            query: readPhotoAlbumQuery,
            variables() {
                return {
                    urlSegment: this.$route.params.albumId
                }
            },
            update (data) {
                this.state.setMetaTitle(data.readOnePhotoAlbum.title)
                return this.photoAlbum = data.readOnePhotoAlbum
            }
        }
    }
}
</script>
